import * as React from 'react';

const FrequentUploaderBadge32 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    d: "M32 16c0 8.836-7.163 16-16 16S0 24.836 0 16 7.164 0 16 0s16 7.163 16 16"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M13.346 15.035a.66.66 0 0 1 1.227-.07l.614 1.341a.66.66 0 0 0 .399.353l1.408.452a.656.656 0 0 1 .072 1.223l-1.346.613a.66.66 0 0 0-.355.397l-.453 1.404a.66.66 0 0 1-1.227.072l-.615-1.342a.66.66 0 0 0-.398-.354l-1.408-.45a.657.657 0 0 1-.073-1.225l1.347-.613a.66.66 0 0 0 .354-.396z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M19.174 10.283a2 2 0 0 1 1.915 1.87l.66 10.57.003.204a2 2 0 0 1-1.67 1.889l-.204.022-10.59.66-.206.002a2 2 0 0 1-1.893-1.666l-.023-.204-.66-10.57a2 2 0 0 1 1.669-2.093l.203-.023 10.59-.659zM8.47 12.438a.5.5 0 0 0-.464.429l-.004.1.66 10.57a.5.5 0 0 0 .53.466l10.591-.659a.5.5 0 0 0 .468-.529l-.66-10.569a.5.5 0 0 0-.429-.463l-.102-.004-10.59.66Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M23.541 6.944a2.05 2.05 0 0 1 1.955 2.136l-.458 10.08a1.814 1.814 0 0 1-1.813 1.73.75.75 0 0 1-.75-.75.75.75 0 0 1 .75-.748v.01-.01a.315.315 0 0 0 .314-.3l.458-10.08a.55.55 0 0 0-.524-.572l-9.758-.442a.55.55 0 0 0-.574.549v.472l-.005.076a.75.75 0 0 1-1.492.001l-.004-.077v-.472a2.05 2.05 0 0 1 2.142-2.045z"
  }
));
FrequentUploaderBadge32.Size = 32;
FrequentUploaderBadge32.Title = "FrequentUploaderBadge";

export { FrequentUploaderBadge32 as default };
